export const STORIES_ACTIVITIES = [
  {
    "_id": "6976a2016cb884ff5deae4b2",
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": [
      {path: "/units/land_nature/images/Its too windy to paddle.webp", correct: true},
      {path: "/units/land_nature/images/It snowed yesterday.webp"}
    ],
    "audio": [{path: "/units/land_nature/audio/Mickwenowe mini story.m4a"}],
    "lesson_type": "story",
    "id": "696a66c07bbf3e4de4b8dc5a",
    "status": "none",
    "active": true,
    "order": 1,
    "activity_type": "ChooseImage",
  },
  {
    "_id": "6976a2016cb884ff5deae4b3",
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": [
      {path: "/units/land_nature/images/Its rainning outside today.webp", correct: true},
      {path: "/units/land_nature/images/It's hot, I made a big fire.webp"},
    ],
    "audio": [{path: "/units/land_nature/audio/Kimion mini story.m4a"}],
    "lesson_type": "story",
    "id": "696a8f0d7bbf3e4de4b8dc82",
    "status": "none",
    "active": true,
    "order": 2,
    "activity_type": "ChooseImage",
  },
  {
    "_id": "6976a2016cb884ff5deae4b3",
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": [
      {path: "/units/land_nature/images/The bird flew away.webp"},
      {path: "/units/land_nature/images/It snowed yesterday.webp", correct: true},
    ],
    "audio": [{path: "/units/land_nature/audio/Sokpin mini story.m4a"}],
    "lesson_type": "story",
    "id": "696a8f0d7bbf3e4de4b8dc82",
    "status": "none",
    "active": true,
    "order": 2,
    "activity_type": "ChooseImage",
  },
  {
    "_id": "6976a2016cb884ff5deae4b3",
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": [
      {path: "/units/land_nature/images/The ground is wet after the rain.webp"},
      {path: "/units/land_nature/images/It's hot, I made a big fire.webp", correct: true},
    ],
    "audio": [{path: "/units/land_nature/audio/Kijede Mini Story.m4a"}],
    "lesson_type": "story",
    "id": "696a8f0d7bbf3e4de4b8dc82",
    "status": "none",
    "active": true,
    "order": 2,
    "activity_type": "ChooseImage",
  },
]
